<template lang="pug">
  .main-block.answers-card
    <!-- .answers-card__header -->
      <!--      .answers-card__user-->
      <!--        .answers-card__user-img-->
      <!--          img.answers-card__user-photo(src="/lms/img/user.jpg")-->
      <!--        .answers-card__user-block-->
      <!--          p.answers-card__user-name Сергей Нагиев-->
      <!--          p.answers-card__user-spec.main-block__label Специализация-->

    .answers-card__body
      h2.main-block__title.answers-card__title 2. Название задания

      p.main-block__text.answers-card__text Текст вопроса, написанный ранее в задании, подгружается вот сюда. Текст вопроса, написанный ранее в задании, подгружается вот сюда. Вопрос?

      p.main-block__label.answers-card__label Ответ участника:

      p.main-block__text.answers-card__text Ответ, который ученик дал на вопрос в задании, подгружается сюда анонимно. Ответ, который ученик дал на вопрос в задании, подгружается сюда анонимно.

      .answers-card__row
        File(
          :file="{fileName: 'file.txt'}"
          :canDelete="false"
        )
    .answers-card__footer
      Comment
</template>

<script>
import File from '@/components/File/File';
import Comment from './Comment';

export default {
  name: 'CardFeed',
  components: {
    File,
    Comment
  },
  props: {
    task: {}
  }
};
</script>
